module.exports = __webpack_public_path__ + "static/media/izmeritelnue_preobrazovateli_vtkz.f80c74ea.pdf";